<template lang="pug">
    v-layout(wrap align-center justify-start class="m-block-page-assessment-object-info")
        v-flex(shrink class="m-block-page-assessment-object-info__container")
            e-typography-heading-3(tag="h2" class="m-block-page-assessment-object-info__body")
                slot(name="title") {{$t('modules.blocks.page.m-block-page-assessment-object-info.title', {name: item.name})}}

        v-flex(shrink class="pa-0")
            e-button-info(@click="openDialog({type:'objectInfo',options:{item}})" class="ma-0")
        v-flex()
            div(v-if="showLegend" class="m-block-page-assessment-object-info__legend-link" @click="openIconInfoDialog") {{$t('modules.blocks.page.m-block-page-assessment-object-info.legend')}}

        v-flex(v-if="onboardingOpen")
            slot(name="title") {{$t('modules.blocks.page.m-block-page-assessment-object-info.onboarding-title')}}

</template>

<script>
    import dialogs from "@mixins/includes/_dialogs";
    import statusIconDialog from "@mixins/additional/_statusIconDialog";

    let name = 'm-block-page-assessment-object-info';
    export default {
        name: name,
        mixins: [dialogs, statusIconDialog],
        props: {
            name: {
                type: String,
                default: name
            },
            item: {
                type: Object,
                required: true
            },
            showLegend: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            onboardingOpen () {
                return this.$store.state.onboardings.isOpen;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .m-block-page-assessment-object-info {
        margin-top: -1.475rem !important;

        &__container {
            padding: 0;
        }

        &__legend-link {
            font-size: 1.13rem;
            color: var(--v-primary-base);
            cursor: pointer;
            float: right;

            @include media(md) {
                float: left;
            }
        }

        &__body {
            font-weight: normal;
        }
        @include updatedMedia(sm) {
            margin-top: 0rem !important;
        }
    }
</style>
